<template>
  <section class="reactionContainer">
    <div
      class="reactionBox"
      v-for="(reaction, index) in mainReactions"
      :key="index"
      @click="addReaction(reaction)"
    >
      <Reaction :reaction="reaction[0]" :option="reaction[1]" :post="post" />
    </div>
    <div v-if="isShowingMore">
      <div
        class="reactionBox"
        v-for="(reaction, index) in reactions"
        :key="index"
        @click="addReaction(reaction)"
      >
        <Reaction :reaction="reaction[0]" :option="reaction[1]" :post="post" />
      </div>
    </div>
    <div
      @click="showMore()"
      class="notShowing"
      :class="{ showing: isShowingMore }"
    ></div>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Reaction from "@/components/Reaction.vue";
import db from "@/db";
//import firebase from "@/firebase";

export default {
  props: ["post", "recentPosts"],

  components: {
    Reaction,
  },

  data: () => ({
    isShowingMore: false,
    mainReactions: [
      [0x1f62e, false],
      [0x1f622, false],
      [0x1f602, false],
      [0x1f44e, false],
      [0x1f44d, false],
      [0x2764, false],
    ],
    reactions: [
      [0x1f973, false],
      [0x1f970, false],
      [0x1f60d, false],
      [0x1f60f, false],
      [0x1f606, false],
      [0x1f600, false],
      [0x1f914, false],
      [0x1f614, false],
      [0x1f62d, false],
      [0x1f624, false],
      [0x1f621, false],
      [0x1f62c, false],
      [0x1f92e, false],
      [0x1f64f, false],
      [0x1f440, false],
      [0x1f9e2, false],
      [0x1f4af, false],
      [0x2757, false],
    ],
  }),
  created() {
    if (this.post.reactions) {
      for (let i = 0; i < this.post.reactions.length; i++) {
        if (this.post.reactions[i].userId == this.user.id) {
          let emojiCode = this.post.reactions[i].unicode
            .codePointAt(0)
            .toString(16);
          let index = this.reactions.findIndex(
            (x) => x[0].toString(16) == emojiCode
          );
          if (index != -1) {
            this.reactions[index][1] = true;
          }
        }
      }
    }
  },

  mounted() {},

  computed: {
    ...mapState("user", ["user"]),
    ...mapState("messageBoard", ["groupId", "groupType"]),
  },

  methods: {
    ...mapActions("messageBoard", ["setAddReaction"]),
    ...mapActions("groupInfo", ["getGroupType"]),

    showMore() {
      this.isShowingMore = !this.isShowingMore;
    },
    addReaction(reaction) {
      this.$store.commit("messageBoard/setAddReaction", false);
      if (reaction[1]) {
        let index = this.post.reactions.findIndex(
          (x) => x.userId == this.user.id
        );
        this.post.reactions.splice(index, 1);
      } else {
        reaction[1] = true;
        let data = {
          unicode: String.fromCodePoint(reaction[0]),
          userId: this.user.id,
        };
        if (!this.post.reactions) {
          this.post.reactions = [];
        }
        let index = this.post.reactions.findIndex(
          (x) => x.userId == this.user.id
        );
        if (index != -1) {
          this.post.reactions.splice(index, 1);
        }
        this.post.reactions.push(data);
      }

      db.collection("posts")
        .doc(this.post.id)
        .update({
          reactions: this.post.reactions,
        });

      let recentIndex = this.recentPosts.findIndex(
        (post) => post.id === this.post.id
      );
      if (recentIndex !== -1) {
        this.recentPosts[recentIndex].reactions = this.post.reactions;
        db.collection(this.groupType)
          .doc(this.groupId)
          .update({
            recentPosts: this.recentPosts,
          });
      }
    },
  },
};
</script>

<style scoped>
.reactionBox {
  display: inline-block;
  white-space: pre-wrap;
  height: 50px;
  width: 50px;
}
.reactionContainer {
  width: 320px;
  text-align: center;
  background-color: white;
  box-shadow: 2px 1px 6px #e0e0e0;
  border-radius: 20px;
  padding: 10px;
  transition: ease-in-out 0.2s;
}
.notShowing {
  height: 30px;
  width: 50px;
  background: url("../assets/arrowIcon.svg") no-repeat 50% 50%;
  border-radius: 10px;
  cursor: pointer;
  margin: auto;
}
.notShowing:hover {
  background-color: #f0f0f0;
}
.showing {
  transform: rotate(180deg);
}
</style>
